import React from "react";
import { components } from "react-select";
import { IE11Flexbug3Fix } from "./IE11Flexbug3Fix";

/**
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const IndicatorsContainer = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(IE11Flexbug3Fix, null, /*#__PURE__*/React.createElement(components.IndicatorsContainer, props, children));
};
//# sourceMappingURL=IndicatorsContainer.js.map